module.exports = __webpack_public_path__ + "static/media/4.2551c5a9.png";